import Vue from "vue";
import RequestBuilder from "./request-builder";

Vue.use(RequestBuilder);